﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import { RouteLink } from "~base/Components/Primitives/Link";
import type { StartPageCustomizations } from "~base/Components/Pages/Home/Start";

export const adminMenu = (role: string): React.ReactNode =>
    role == "tenantadmin" || role == "sysadmin" ? (
        <RouteLink
            style={{ color: "#9c9c9c" }}
            forceLoadAsExternal={true}
            to={"/AvtalatAdmin"}
        >
            Administration
        </RouteLink>
    ) : (
        []
    );

export default {
    adminMenu: adminMenu,
    additionalAllowedOrganizationTypes: [],
    customStyles: {
        header: {
            padding: "unset",
            marginTop: "24px",
        },
    },
} as StartPageCustomizations;
